module.exports = __webpack_public_path__ + "static/media/dataFiscal.966742c8.jpg";